<template>
  <div>
    <div  class="img-bj"></div>
    <div class="main">
      <router-view/>
    </div>
  </div>
</template>

<script>
  export default {
     data(){
              return{

              }
     },

     beforeMount(){
            if(document.getElementById('app').clientWidth <= 1000){
              //移动端
               location.href = location.href.split('/login/').join('/m/')
            }
     },
     mounted(){

     }

  }
</script>

<style lang="scss" scoped>
.img-bj{
  background-image: url('../../assets/images/mvmc_login_bj.jpg');
  width: 1920px;
  height: 1080px;
  background-size: 100% 100%;
  position: fixed;
  top: 50%;
  left: 50%;
  margin: -540px 0 0 -960px;
}

.main{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
</style>